<template>
  <MaskLayer v-if="isClose">
    <Slider class="w-25" @close="close">
      <div class="flex-grow-1 overflow-auto bg-gray100">
        <McfWriteOff />
      </div>
    </Slider>
  </MaskLayer>
</template>

<script>
import { mapMutations } from 'vuex';
import MaskLayer from '@/components/MaskLayer.vue';
import Slider from '@/views/mcfwallet/Slider.vue';
import McfWriteOff from '@/views/mcfwallet/McfWriteOff.vue';

export default {
  data() {
    return {
      // 關閉鈕
      isClose: true,
    };
  },
  components: {
    MaskLayer,
    Slider,
    McfWriteOff,
  },
  methods: {
    ...mapMutations('memberSource', ['setMemberSourceData']),
    close() {
      this.setMemberSourceData({ id: 'isWriteOffClick', value: false });
      this.setMemberSourceData({ id: 'isTransfer', value: false });
      this.isClose = false;
    },
  },
};
</script>

<style>
</style>
